import React from "react";
import LockIcon from "@material-ui/icons/Lock";
import { Typography, Fade } from "@material-ui/core";

import "./LockScreen.css";

function LockScreen() {
  return (
    <Fade in={true} style={{}}>
      <div className="wsh-LockScreen">
        <Typography variant="h2" align="center" gutterBottom>
          LOCKED
        </Typography>
        <div style={{ fontSize: "5em" }}>
          <LockIcon fontSize="inherit" />
        </div>
        <Typography variant="body1" align="center" gutterBottom>
          We pay rent too. This content is for paid subscribers only.
        </Typography>
      </div>
    </Fade>
  );
}

export default LockScreen;
